export enum Tab {
  Price,
  Payment,
}
